import React, { useState } from 'react';
import logo from '../../Images/Logo.png';

const Header = () => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isDropdownOpenReservations, setIsDropdownOpenReservations] = useState(false);

    const toggleDropdownReservations = () => {
        setIsDropdownOpenReservations(!isDropdownOpenReservations);
    }

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        setIsDropdownOpen(false);
    };

    const handleLinkClick = () => {
        setIsMenuOpen(false);
        setIsDropdownOpen(false);
    };

    return (
        <>
            <header
                className={`fixed top-0 left-0 w-full z-50 bg-white/30 backdrop-blur-md shadow-md transition-all duration-300 ease-in-out ${isMenuOpen ? 'h-auto' : ''
                    }`}
            >
                <nav className="border-gray-300 px-4 lg:px-6">
                    <div className="contact-bar rounded-b-lg text-white text-sm py-2 px-4">
                        <div className="max-w-screen-xl mx-auto flex flex-col md:flex-row justify-between items-center gap-2 text-center md:text-left">
                            <div className="text-white">
                                📞 <span className="font-bold">Contact :</span>+91 9327953295 / +91 6377659957
                            </div>
                            <div className="text-white">
                                ✉️ <span className="font-bold">Email :</span> contact@vamikatours.com
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col md:flex-row justify-between items-center w-full max-w-screen-xl mx-auto relative">
                        {/* Logo and toggle button */}
                        <div className="flex justify-between items-center w-full md:w-auto">
                            <a href="/" className="flex items-center" onClick={handleLinkClick}>
                                <img src={logo} alt="VamikaTours Logo" className="w-[100px] md:w-[95px]" />
                                <span className="text-[1.7rem] -ml-3 md:-ml-4 lg:ml-0 font-bold whitespace-nowrap ">
                                    VamikaTours
                                </span>
                            </a>
                            <button
                                onClick={toggleMenu}
                                className="md:hidden flex items-center justify-center text-gray-700"
                            >
                                {isMenuOpen ? (
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                ) : (
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                                    </svg>
                                )}
                            </button>
                        </div>

                        {/* Navigation Links */}
                        <div
                            className={`w-full mb-3 sm:mb-0 md:w-auto transition-all duration-300 ease-in-out ${isMenuOpen ? '' : 'hidden md:flex'} md:items-center md:justify-center ${isMenuOpen ? 'max-h-[500px]' : 'max-h-0 md:max-h-full md:py-0'
                                }`}
                        >
                            <ul className="flex flex-col md:flex-row items-center font-medium space-y-4 md:space-y-0 md:space-x-8">
                                <li><a href="/" onClick={handleLinkClick} className="py-2 text-gray-700 hover:text-yellow-600">Home</a></li>
                                <li className="relative inline-block">

                                    <button
                                        onClick={toggleDropdown}
                                        className="flex items-center text-gray-700 hover:text-yellow-600"
                                    >
                                        Packages
                                        <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                                            <path
                                                fillRule="evenodd"
                                                d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 111.08 1.04l-4.25 4.65a.75.75 0 01-1.08 0l-4.25-4.65a.75.75 0 01.02-1.06z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </button>
                                    {isDropdownOpen && (
                                        <div className="absolute left-0 mt-2 w-56 bg-white rounded-md shadow-lg z-50">
                                            <a href="/domestic" onClick={handleLinkClick} className="block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-yellow-600">
                                                Domestic
                                            </a>
                                            <a href="/international" onClick={handleLinkClick} className="block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-yellow-600">
                                                International
                                            </a>
                                            <a href="/honeymoon" onClick={handleLinkClick} className="block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-yellow-600">
                                                Honeymoon
                                            </a>
                                        </div>
                                    )}
                                </li>
                                <li className="relative inline-block">
                                    <button
                                        onClick={toggleDropdownReservations}
                                        className="flex items-center text-gray-700 hover:text-yellow-600"
                                    >
                                        Reservations
                                        <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                                            <path
                                                fillRule="evenodd"
                                                d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 111.08 1.04l-4.25 4.65a.75.75 0 01-1.08 0l-4.25-4.65a.75.75 0 01.02-1.06z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </button>
                                    {isDropdownOpenReservations && (
                                        <ul className="absolute left-0 mt-2 w-56 bg-white rounded-md shadow-lg z-50">
                                            <li>
                                                <a
                                                    href="/flight-booking"
                                                    onClick={handleLinkClick}
                                                    className="block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-yellow-600"
                                                >
                                                    Flight Booking
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="/hotel-reservation"
                                                    onClick={handleLinkClick}
                                                    className="block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-yellow-600"
                                                >
                                                    Hotel Reservation
                                                </a>
                                            </li>
                                        </ul>
                                    )}
                                </li>


                                <li><a href="/about-us" onClick={handleLinkClick} className="py-2 text-gray-700 hover:text-yellow-600">About</a></li>
                                <li><a href="/contact" onClick={handleLinkClick} className="py-2 text-gray-700 hover:text-yellow-600">Contact</a></li>
                            </ul>
                        </div>
                    </div>
                </nav>

            </header>
        </>
    );
};

export default Header;